import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';

import BrandedCard from '../../containers/BrandedCard/BrandedCard';
import { Button } from '../../elements/Button';
import { BrandProps } from '../../../../clientConfig';
import { OPENID_PARAMS } from '../../../../types/openid_enum';
import { useValidatedUrl } from '../../../hooks/useValidatedUrl';
import { sendEventByType } from '../../../services/amplitudeClient';
import { AmplitudeEventType } from '../../../../analytics/amplitudeEvents';
import { UsernameRecoveryState } from '../../../../types/reactTypes';

function UsernameRecoveryHandOff({ brandInfo }: BrandProps) {
    const { t } = useTranslation();
    const history = useHistory();
    const validateRedirectUrl = useValidatedUrl();
    const location = useLocation<UsernameRecoveryState>();
    const requiresResetPassword = location.state?.requiresResetPassword;
    const search = document.location.search;
    const searchParams = new URLSearchParams(search);
    const requestedRedirectUrl = searchParams.get(OPENID_PARAMS.REDIRECT_URI) || (searchParams.get(OPENID_PARAMS.REDIRECT_URL) as string);
    useEffect(() => {
        sendEventByType(AmplitudeEventType.UsernameRecovery_HandoffPage_Load);
    }, []);

    const redirect = async () => {
        sendEventByType(AmplitudeEventType.UsernameRecovery_HandoffPage_SignIn);
        if (requestedRedirectUrl) {
            let destinationUrl = requestedRedirectUrl;
            if (requiresResetPassword) {
                // add the reset_password_flow=true property
                const isApplicationRelative = requestedRedirectUrl.startsWith('/');
                const urlBuilder = new URL(requestedRedirectUrl, window.location.origin);
                urlBuilder.searchParams.set('reset_password_flow', 'true');
                destinationUrl = isApplicationRelative ? `${urlBuilder.pathname}${urlBuilder.search}${urlBuilder.hash}` : urlBuilder.href;
            }
            const validatedRedirectUrl = await validateRedirectUrl(destinationUrl);
            if (validatedRedirectUrl) {
                window.location.href = validatedRedirectUrl;
            }
        } else {
            history.push('/error');
        }
    };

    return (
        <>
            <BrandedCard brand={brandInfo}>
                {{
                    header: (
                        <>
                            <Typography variant='h2'>{t('Username Recovery')}</Typography>
                        </>
                    ),
                    content: (
                        <>
                            <Grid container justify='center' item xs={10} className='txtAlignCenter'>
                                <Typography variant='body1'>
                                    {t('We will send you an email with your verified username at the email associated with your account.')}
                                </Typography>
                                {requiresResetPassword ? (
                                    <>
                                        <br />
                                        <Typography variant='h3'>{t('To access your account, please reset your password.')}</Typography>
                                    </>
                                ) : null}
                            </Grid>
                        </>
                    ),
                    actions: (
                        <>
                            <Grid container justify='center' item xs={12}>
                                <Button type='button' variant='contained' onClick={() => redirect()}>
                                    {requiresResetPassword ? t('Reset Password') : t('Sign In')}
                                </Button>
                            </Grid>
                        </>
                    ),
                }}
            </BrandedCard>
        </>
    );
}

export default UsernameRecoveryHandOff;
